'use strict'

require '../../../../../core/frontend/groupon_modules/ariaKeyNavigation'
stickyHeader = require '../sticky_header'

class Groupon.LS.Header.PNPrimaryNav extends Groupon.AriaMenuNavigation

  constructor: (@$primaryNav) ->
    @initialize()
    @bind()

  initialize: ->
    @$primaryTabs = @$primaryNav.find(".primary-nav-tab")
    @$subnavs = $('.subnav-flyout')
    @localHeightCalculated = false
    @timeoutID = 0
    @$railSlide = $('#ls-rail-slide')

    setTimeout @moveActiveMarker, 100
    @setAriaAttributes()

    $(window).one 'load', ->
      Groupon.Utils.lazyLoadImages { skip_invisible: false }, '#subnav .lazy-load'

  bind: ->

    if Groupon.PageFlags.isLegacyResponsive
      moveMarkerOnResize = =>
        @moveActiveMarker()

      $(window).on 'resize', _.debounce(moveMarkerOnResize, 50)

    closeSubnav = =>
      # FIXME: this selector might not work in touch-device context
      unless $('.primary-nav:hover').length # prevent closing when mouse enters primary nav from the flyouts
        @closeSubnav()
        window.clearTimeout(@timeoutID)

      # LS-2925 resume sticky header
      stickyHeader.resume()

    startsSubnavTimer = => @hovTimeout = setTimeout closeSubnav, 50
    cancelSubnavTimer = => clearTimeout @hovTimeout

    startsActiveMarkerTimer = => @activeMarkerTimeout = setTimeout @moveActiveMarker, 50
    cancelActiveMarkerTimer = => clearTimeout @activeMarkerTimeout

    @$primaryNav.on
      mouseenter: ->
        cancelSubnavTimer()
        cancelActiveMarkerTimer()
      mouseleave: ->
        startsSubnavTimer()
        startsActiveMarkerTimer()

    @$primaryTabs.on
      mouseenter: (e) =>
        cancelActiveMarkerTimer()
        @moveActiveMarker $(e.currentTarget)

    @$subnavs.on
      mouseenter: ->
        cancelSubnavTimer()
        cancelActiveMarkerTimer()
      mouseleave: ->
        startsSubnavTimer()
        startsActiveMarkerTimer()

    # determine tabs with subnavs
    $primaryTabsLinks = @$primaryTabs.find('a').map ->
      if $('#subnav-' + @parentNode.id).length
        return this

    if Groupon.LS.hasTouch
      $primaryTabsLinks.addClass('lstouch')

      # bind event to tab's <a>
      $primaryTabsLinks.on 'lstouch', (e) =>
        parent = e.currentTarget.parentNode

        # toggle subnav visibility
        if $('#subnav-' + parent.id).is(':visible')
          @closeVisibleSubnav()
        else
          # close other header menus
          $('html').trigger 'tap'
          # open subnav
          $(parent).trigger 'touch', e

        return false # required to prevent propagation to the link target

      # close visible subnav when tapping any element but the flyouts
      $('html').on 'tap', (e) =>
        # test for subnav to be open AND if the event hasn't be triggered
        # within the channel navigation primary nav and flyouts
        if $('.subnav').height() and $(e.target).closest('.primary-nav, .subnav-flyout', '#ls-channel-nav').length == 0
          @closeVisibleSubnav()

    # bind event to tab's <li> to open subnav
    @$primaryTabs.on 'mouseenter touch', (e) =>
      e.stopPropagation()
      @handleOpenSubnav(e)

    # bind keyboard handling to links
    @ariaBindMenuTrigger($primaryTabsLinks)

  closeSubnav: ->
    # reset tabindex
    @$currentFlyoutLinks?.attr('tabindex', '-1')

    @$subnavs.hide()

    @$primaryTabs.find('a.active').removeClass('active')

  # used by keyboardNavigation
  closeVisibleSubnav: ($activeTab) ->
    @closeSubnav()
    $activeTab?.focus()
    @$primaryTabs.find('a.active').removeClass('active')

  handleOpenSubnav: (e) =>
    window.clearTimeout(@timeoutID)
    flyoutDelay = if $('.subnav-flyout').is(':visible') then 0 else 300
    $tab = $(e.currentTarget)
    $tab = $tab.parent() if $tab.is('a')
    eventType = e.type
    $flyout = $("#subnav-#{$tab.attr('id')}")

    @closeSubnav() if not $flyout.length or $flyout.not(".ls-s-flyout-enabled").length

    # When API call in layout-service fails, we will not generate flyout for a tab,
    # and the default static fallback is designed to show no subnav.
    if $flyout.length

      # LS-2925 pause sticky header
      stickyHeader.pause()

      $('.typeahead-response').hide()
      openSubnav = => @openSubnav $tab, $flyout, eventType
      if flyoutDelay
        @timeoutID = setTimeout openSubnav, flyoutDelay
      else
        openSubnav()

  openSubnav: ($tab, $flyout, eventType) =>
    $activeTab = $tab.find('a').eq(0)
    $activeTab.addClass('active')

    $flyout.trigger('tab:active') # no-op for non listeners
    $flyout.show()

    # handle keyboard navigation
    if eventType is 'keydown'
      $currentFlyoutLinks = $flyout.find('a')

      # set focus on first link
      $currentFlyoutLinks.attr('tabindex', '-1').eq(0).focus().attr('tabindex', '0')

      #init aria keyboard navigation per subnav
      @initMenuNavigation($activeTab, $flyout, $currentFlyoutLinks)

  moveActiveMarker: ($link = @$primaryTabs.filter('.default')) =>
    $link = @$primaryNav.find('.ls-current-app') unless $link.length
    if $link.is('li')
      $link = $link.find "a"
    if $link.length
      {left}   = $link.position()
      position = left - 10
      width    = $link.width() + 20
      @$railSlide.show().css('left', position).css('width', width)
    else
      @$railSlide.hide()

  setRailSlide: ($link) =>
    if $link.length
      {left} = $link.position()
      center = left + ($link.width() / 2)
      @$railSlide.show().css('left', center)

  # override AriaMenuNavigation functions
  ariaBindMenuTrigger: ($trigger) ->
    $trigger.off 'keydown'
    $trigger.on 'keydown', (e) =>
      {SPACE, DOWN} = Groupon.Keymap
      if e.keyCode in [SPACE, DOWN]
        @handleOpenSubnav(e)

  ariaCloseMenu: ($trigger) ->
    @closeVisibleSubnav($trigger)

  setAriaAttributes: ->
    for tab in @$primaryTabs
      $tab = $(tab)
      tabID = tab.id
      $subnav = $("#subnav-#{tabID}")
      @initAriaAttributes($tab.find('a'), $subnav, $subnav.find('a'))



// WEBPACK FOOTER //
// ./modules/gig_body/header/frontend/views/pn_primarynav.coffee